import {
  EI_BACK_TO_LIST_CLICKED,
  EI_INFO_ICON_CLICKED,
  EI_INFO_LINK_CLICKED,
  EI_MODAL_VIEWS_OPEN,
  EI_PARTIAL_INFO_ACK,
  EI_SEE_ENGAGEMENTS_CLICKED,
  EI_SEE_ENGAGEMENTS_CLOSED,
  EI_SEE_ENGAGEMENTS_SHOWN,
  EI_VIEWER_DETAILS_CLICKED,
} from 'constants/events';
import * as analytics from 'utilities/analytics';

let videoId;

export const initForVideo = id => {
  videoId = id;
};

export const trackModal = videoId =>
  analytics.track(EI_MODAL_VIEWS_OPEN, { videoId });
export const trackShown = () =>
  analytics.track(EI_SEE_ENGAGEMENTS_SHOWN, { videoId });
export const trackActivate = () =>
  analytics.track(EI_SEE_ENGAGEMENTS_CLICKED, { videoId });
export const trackExit = () =>
  analytics.track(EI_SEE_ENGAGEMENTS_CLOSED, { videoId });
export const trackPartialInfoAck = () =>
  analytics.track(EI_PARTIAL_INFO_ACK, { videoId });
export const trackBackToList = () =>
  analytics.track(EI_BACK_TO_LIST_CLICKED, { videoId });
export const trackViewerDetails = () =>
  analytics.track(EI_VIEWER_DETAILS_CLICKED, { videoId });
export const trackInfoIcon = (source = {}) =>
  analytics.track(EI_INFO_ICON_CLICKED, { videoId, ...source });
export const trackInfoLink = () =>
  analytics.track(EI_INFO_LINK_CLICKED, { videoId });
